module.exports = __webpack_public_path__ + "static/media/dish.effe5b29.png";